import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { VendorContextService, isGroceryVendor } from '@shared';

/**
 * Guard to restrict routes to grocery vendors only
 * Redirects to orders if vendor is not a grocery vendor
 */
export const requireGroceryVendor: CanActivateFn = async () => {
  const vendorContext = inject(VendorContextService);
  const router = inject(Router);

  const vendor = await vendorContext.waitForVendorSnapshot();
  
  if (!vendor) {
    console.warn('[GroceryVendorGuard] No vendor found, redirecting to orders');
    router.navigate(['/tabs/orders']);
    return false;
  }

  if (!isGroceryVendor(vendor)) {
    console.warn('[GroceryVendorGuard] Vendor is not a grocery vendor, redirecting to orders', {
      vendorId: vendor.id,
      businessType: vendor.businessType,
    });
    router.navigate(['/tabs/orders']);
    return false;
  }

  console.log('[GroceryVendorGuard] Vendor is a grocery vendor, allowing access', {
    vendorId: vendor.id,
    businessType: vendor.businessType,
  });
  return true;
};

/**
 * Restrict routes to non-grocery vendors (e.g. menu categories for restaurant menus).
 */
export const requireNonGroceryVendor: CanActivateFn = async () => {
  const vendorContext = inject(VendorContextService);
  const router = inject(Router);

  const vendor = await vendorContext.waitForVendorSnapshot();

  if (!vendor) {
    router.navigate(['/tabs/orders']);
    return false;
  }

  if (isGroceryVendor(vendor)) {
    router.navigate(['/tabs/orders']);
    return false;
  }

  return true;
};

